import { TOP_NAV_PATHS } from '@src/components/NavigationSidebar/Nav';
import { checkRequiredPermissions } from '@src/utils/layoutPermissions';
import { useWLOrgConfigContext, useWLRoleAuth, type CustomerUserConfigNavigationItem } from '@talos/kyoko';

export function useNavigationItems(): CustomerUserConfigNavigationItem[] {
  const { isAuthorized } = useWLRoleAuth();
  const { config } = useWLOrgConfigContext();

  return (config.navigationItems ?? TOP_NAV_PATHS).filter(ni =>
    checkRequiredPermissions(ni.requiredPermissions, isAuthorized)
  );
}
